import { computed } from 'mobx';
import type { IComputedValue } from 'mobx';

import { actionMenuStore } from '../../stores';

export const isChangeDistanceAvailable: IComputedValue<boolean> = computed(() => {
  const distance = actionMenuStore.distance;

  if (!distance || distance.deleted_at || distance.withTeam) {
    return false;
  }

  return Boolean(distance.changeDistanceSettings?.eligibleDistances.length);
});
